<button
	(click)="toggleNotificationsCard(!isNotificationsCardOpen)" 	
	(keydown.enter)="toggleNotificationsCard(true)"
	(keydown.esc)="toggleNotificationsCard(false)"
	class="notifications-menu zk-mr-2 md:zk-mr-5"
>
	<div>
		<span class="freud-icon freud-icon-bell freud-icon-md">
		</span>	
		<circle *ngIf="this.newNotificationsCounter > 0" class="new-notifications-icon" [outline]="true"></circle>
	</div>
</button>
<overlay [isActive]="isNotificationsCardOpen">
	<notifications-card *ngIf="isNotificationsCardOpen" (onNotificationSeen)="onNotificationSeen($event)" (onClose)="toggleNotificationsCard(false)" [hasNewNotifications]="this.newNotificationsCounter > 0" [isOpen]="isNotificationsCardOpen"></notifications-card>
</overlay>